import { proxy } from 'valtio/vanilla'
import { getSharedState } from '../valtio'

// A framework-agnostic MIRROR of the ticket route params. vue-router stays the
// source of truth in the app; the Vue composable pushes params here on every
// change (see useTicketRouteParams), so state selectors and any non-Vue consumer
// can read them without importing vue-router.
export interface TicketRouteParams {
  connectionId: number
  conversationId: string
  messageId: string
  transcriptionId: string
  transcriptionMessageId: string
  disputeId: string
  assignmentId: string
  calibrationSessionId: string
  reviewId: string
}

export const emptyTicketRouteParams: TicketRouteParams = {
  connectionId: 0,
  conversationId: '',
  messageId: '',
  transcriptionId: '',
  transcriptionMessageId: '',
  disputeId: '',
  assignmentId: '',
  calibrationSessionId: '',
  reviewId: '',
}

export const ticketRouteParamsState = getSharedState('ticket-route-params', () =>
  proxy<TicketRouteParams>({ ...emptyTicketRouteParams }),
)
